<template>
    <div class="content">
        <div class="content-wrap">
            <div class="top">
                <mq-layout mq="mobile">
                    <MobileMenubar></MobileMenubar>
                </mq-layout>
                <mq-layout mq="laptop+">
                    <LaptopMenubar></LaptopMenubar>
                </mq-layout>
            </div>

            <div class="container-login" align="center">
                <div class="main-text" align="center">
                    <p class="big-text" align="center">{{l10.All_Parents_Signin_Title1}}</p>
                    <p class="sub-text" align="center">{{l10.All_Parents_Signin_Title1_Description1}}</p>
                </div>

                <form @submit.prevent="onSubmit(email, password)">
                    <div class="form1">
                        <input class="user" type="email" align="center" v-model="email" :placeholder="l10.All_Parents_Signin_Title1_InputBox1">
                    </div>

                    <div class="clearfix"></div>

                    <div class="form1">
                        <input :class="{ 'pass': !wrongPassword, 'pass-wrong': wrongPassword }"
                            type="password" align="center" v-model="password" :placeholder="l10.All_Parents_Signin_Title1_InputBox2">
                    </div>

                    <div v-if="msg" class="wrong-text">{{msg}}</div>

                    <div class="next">
                        <input class="subm" type="submit" align="center"
                            :value="[[ l10.All_Parents_Signin_Title1_Button1 ]]"
                        />
                    </div>
                </form>
                <div class="clearfix"></div>

                <div class="member-signup" align="center">
                    <a href="#" @click="signupEmail">{{l10.All_Parents_Signin_Title1_Button3}} &nbsp;&nbsp;<span style="color: #e6e6e6"> |</span></a>
                </div>
                <div class="forgot" align="center">
                    <a href="/recover">&nbsp;&nbsp;{{l10.All_Parents_Signin_Title1_Button2}}</a>
                </div>

            </div>

        </div>

        <div class="container">
            <mq-layout mq="mobile">
                <MobileFooter></MobileFooter>
            </mq-layout>
            <mq-layout mq="laptop+">
                <LaptopFooter></LaptopFooter>
            </mq-layout>
        </div>

        <ChangePassword v-if='showChangePassword'
                        @show-message="handleShowMessage"
                        @change-later="handleChangePasswordLater"
                        @change-complete="handleChangePasswordComplete" />

        <SimplePopup    v-if='isSimplePopup'
                        :popupType='simplePopupType'
                        :popupMessage='simplePopupMessage'
                        @close-popup="handleCloseSimplePopup" />
    </div>
</template>
<script>
import LaptopMenubar from '@/components/menubar/LaptopLayout.vue'
import MobileMenubar from '@/components/menubar/MobileLayout.vue'
import LaptopFooter from "@/components/footer/FooterLaptop.vue";
import MobileFooter from "@/components/footer/FooterMobile.vue";
import ChangePassword from './ChangePassword'
import SimplePopup from './SimplePopup'

export default {
    name: "Signin",
    components: { LaptopMenubar, MobileMenubar, LaptopFooter, MobileFooter, ChangePassword, SimplePopup },
    mounted(){
    },
    beforeCreate() {
        const lang = this.$route.query.lang;
        if (lang) {
		    this.$store.commit('setLanguage', lang);
        }
    },
    created() {
        const sessionId = this.$store.getters.sessionId//isSignedIn;
        if (this.$store.getters.sessionId && this.$store.getters.accountId) {
            this.$store
                .dispatch("verifySession", { sessionId })
                .then(() => {
                    this.redirect();
                });
        }
    },
    data() {
        const text = require("../../text/parent/laptop.js").default;
        const l10n = text[this.$store.state.lang]
            ? text[this.$store.state.lang]
            : text["en"];
        return {
            l10: l10n,
            email: "",
            password: "",
            msg: "",
            wrongPassword: false,

            showChangePassword: false,
            simplePopupType: undefined,
            simplePopupMessage: '',
            isSimplePopup: false,
        };
    },
    methods: {
        redirect() {
            this.$store.dispatch("redirect");
        },
        onSubmit(email, password) {
            if (!email || !password) {
                this.msg = "";
                this.wrongPassword = false;
                return;
            }

            this.$store
                .dispatch("signin", { email, password })
                .then((data) => {
                    if (data.passwordExpired) {
                        this.showChangePassword = true
                    } else {
                        this.redirect()
                    }
                })
                .catch(({ message }) => {
                    this.setErrorMsg(this.$store.state.errCode);
                });
        },
        signupEmail() {
            // signup
            const { search } = window.location;
            this.$router.push("/signup/email" + search)
        },
        setErrorMsg(errCode) {
            this.wrongPassword = false;
            if ( "All_Parents_Error_" + errCode in this.l10) {
                this.msg = this.l10["All_Parents_Error_" + errCode];
            } else {
                this.msg = "Unknown error occurred.";
            }

            if (errCode === 'CA06') {
                this.wrongPassword = true;
            }
        },

        handleShowMessage(msg) {
            if (msg == 'needlogin') {
                this.simplePopupType = 'needlogin'
                this.simplePopupMessage = this.l10.All_Parents_Signin_Title1_ErrorMessage5
            } else if(msg == 'CA01') {
                this.simplePopupType = 'CA01'
                this.simplePopupMessage = this.l10.All_Parents_Error_CA01
            } else {
                this.simplePopupType = 'message'
                this.simplePopupMessage = msg
            }
            this.isSimplePopup = true
        },

        handleCloseSimplePopup() {
            if (this.showChangePassword && this.simplePopupMessage == this.l10.All_Parents_ChangePassword_Message1) {
                // this.showChangePassword = false
                this.redirect()
            }
        },

        handleChangePasswordComplete() {
            // this.showChangePassword = false
            this.handleShowMessage(this.l10.All_Parents_ChangePassword_Message1)

        },

        handleChangePasswordLater() {
            // this.showChangePassword = false
            this.redirect()
        }
    }
};
</script>

<style src="@/assets/account/main.css"></style>
<style scoped>
.top {
    height: 100px;
    background-color: #42c0ff;
}
.container {
    margin: 0 auto;
    height: auto;
    min-height: 100px;
    max-width: 1024px;
    background-color: #ffffff;
}
.content-wrap {
    background-color: #fffcf7;
    padding-bottom: 10px;
}

</style>



// WEBPACK FOOTER //
// src/pages/account/SigninEmail.vue